/**
 * Created by pajicv on 9/28/18.
 */
import React from 'react';
import {Card, CardContent, TextField, Button, withStyles, CardActionArea} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';

const styles = theme => ({
  box: {
      width: 450,
      height: 250,
      marginBottom: 30,
      position: 'relative'
  },
    nameContent: {
        height: 40
    },
    deleteButton: {
      position: 'absolute',
        top: -20,
        right: -20,
        width: 40,
        height: 40,
        zIndex: 100
    }
});

class TitleDescriptionBox extends React.Component {
    render() {
        const {classes, name, description, onNameChange, onDescriptionChange, onDeleteClick, onNameBlur, onDescriptionBlur, onClick } = this.props;
        return (
            <div style={{position: 'relative'}}>
                <Button
                    className={classes.deleteButton}
                    variant="fab"
                    color="primary"
                    aria-label="Delete"
                    onClick={onDeleteClick}
                >
                    <DeleteIcon fontSize="small"/>
                </Button>
            <Card className={classes.box}>
                    <CardContent className={classes.nameContent}>
                        <TextField
                            style={{width: 400}}
                            label="Name"
                            margin="normal"
                            value={name}
                            onChange={onNameChange}
                            onBlur={onNameBlur}
                            InputLabelProps={{ shrink: true }}
                        />
                    </CardContent>
                    <CardContent>
                        <TextField
                            style={{width: 400}}
                            label="Beschreibung"
                            multiline
                            rows="4"
                            margin="normal"
                            value={description}
                            onChange={onDescriptionChange}
                            onBlur={onDescriptionBlur}
                            InputLabelProps={{ shrink: true }}
                        />
                    </CardContent>
            </Card>
            </div>
        );
    }
}

export default withStyles(styles)(TitleDescriptionBox);


// WEBPACK FOOTER //
// ./src/components/common/TitleDescriptionBox.js